// Shopify Add to Cart Time Restriction Script
// Disables add to cart button from 10 PM to 9 AM (Europe/Bucharest)

(function() {
  'use strict';

  const CONFIG = {
    timezone: 'Europe/Bucharest',
    startHour: 13,  // 10 PM
    endHour: 9,     // 9 AM
    buttonSelectors: [
      'button[name="add"]',
      '.product-form__submit',
      '.add-to-cart',
      '#AddToCart',
      'button.btn--add-to-cart',
      '[data-add-to-cart]'
    ],
    formSelectors: [
      'form[action*="/cart/add"]',
      '.product-form',
      '[data-product-form]'
    ]
  };

  function isStoreOpen() {
    const now = new Date();
    const bucharestTime = new Date(now.toLocaleString('en-US', { timeZone: CONFIG.timezone }));
    const currentHour = bucharestTime.getHours();
    return !(currentHour >= CONFIG.startHour || currentHour < CONFIG.endHour);
  }

  function blockEvent(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }

  function disableAddToCart() {
    // Disable buttons
    CONFIG.buttonSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(button => {
        if (button.hasAttribute('data-hours-disabled')) return;
        
        button.disabled = true;
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
        button.style.pointerEvents = 'none';
        button.setAttribute('data-hours-disabled', 'true');
        button.textContent = 'Momentan indisponibil';
        
        button.addEventListener('click', blockEvent, true);
      });
    });

    // Block form submissions
    CONFIG.formSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(form => {
        if (form.hasAttribute('data-hours-disabled')) return;
        
        form.setAttribute('data-hours-disabled', 'true');
        form.addEventListener('submit', blockEvent, true);
      });
    });
  }

  function init() {
    if (!isStoreOpen()) {
      disableAddToCart();
      
      new MutationObserver(() => {
        if (!isStoreOpen()) disableAddToCart();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setInterval(() => {
    if (!isStoreOpen()) disableAddToCart();
    else location.reload();
  }, 60000);

})();